'use strict';

function PerformanceReviewInviteController(performanceReviewService, $window, $location, $modal, $filter) {
  var INVITE_STATES = {
    COMPLETED: 'initial_completed',
    PENDING: 'initial_pending',
    STARTED: 'initial_started',
  };


  var vm = this;

  vm.$onInit = $onInit;
  vm.setEmail = setEmail;
  vm.postInvite = postInvite;
  vm.postInvitations = postInvitations;
  vm.postEditedPendingInvite = postEditedPendingInvite;
  vm.postEditedOngoingInvite = postEditedOngoingInvite;
  vm.postResendInvite = postResendInvite;
  vm._requestAll = _requestAll;
  vm._refreshAll = _refreshAll;
  vm._refreshInvites = _refreshInvites;
  vm._refreshInvited = _refreshInvited;
  vm.deleteInvite = deleteInvite;
  vm.isReviewDisabled = isReviewDisabled;
  vm.enableReview = enableReview;
  vm.updateInvites = updateInvites;

  vm.hasInvites = hasInvites;
  vm.hasInvited = hasInvited;

  vm.isEditDisabled = function (index, invite) {
    var basis = getBasis(invite);
    if (angular.isUndefined(basis)) {
      // When invite is sent it doesn't refresh "basis" properly
      // Ugly assumption that current invite is not part of the basis
      // hence getBasis will return undefined and it's possible to edit.
      return false;
    }
    if (basis) {
      if (basis.follow_up) {
        if (basis.follow_up.state === 'follow_up_created') {
          return false;
        }
        return true;
      }
      if (basis.initial_assessment) {
        if (basis.initial_assessment.state === INVITE_STATES.PENDING) {
          return false;
        }
        return true;
      }
      return basis.agreement_completed;
    }
    return true;
  };

  vm.isResendDisabled = function (index, invite) {
    var basis = getBasis(invite);
    if (basis) {

      if (basis.initial_assessment) {
        if (basis.initial_assessment.state === INVITE_STATES.PENDING) {
          return false;
        }
        return true;
      }

      return basis.agreement_completed;
    }
    return true;
  };


  function $onInit() {
    vm._refreshAll({data: vm.data});
    vm.location = $location.path();
    updateInvites();
  }

  function updateInvites() {
    vm.invites.forEach(function (invite) {
      invite.canBeDeleted = true;
    });
  }

  function setEmail(email) {
    vm.email = email;
  }

  function postInvite(invite) {
    return performanceReviewService.create
      .invite(vm.round, invite.first_name, invite.last_name, invite.email, invite.transpire)
      .then(vm._requestAll)
      .catch(function (response) {
        var message = 'invite.conflict.duplicate';

        if (response.data.error === 'Invalid manager') {
          message = 'invite.conflict.taken';
        }

        var modal = $modal({template: require('./performance-review-invite.modal.user-conflict.html'), show: true});
        modal.$scope.errorMessage = message;
      });
  }

  function postInvitations() {
    return performanceReviewService.create
      .inviteTokens(vm.round, vm.email.subject, vm.email.message, vm.email.signature)
      .then(vm._refreshInvited)
      .then(vm._refreshInvites);
  }

  function postEditedPendingInvite(index, invite) {
    return postEditedInvite(invite, false);
  }

  function postEditedOngoingInvite(index, invite) {
    var basis = getBasis(invite);
    if (basis) {
      if (basis.follow_up && basis.follow_up.invite_url) {
        $window.location.href = basis.follow_up.invite_url;
        return;
      }
    }
    return postEditedInvite(invite, true);
  }

  function postEditedInvite(invite, isOngoingInvite) {
    var modal = $modal({template: require('./performance-review-invite.modal.edit.html'), show: true});

    modal.$scope.data = invite;

    var subject = $filter('translate')('invite.performance.review.resend.subject');
    var body = $filter('translate')('invite.performance.review.resend.body');
    var signature = $filter('translate')('standard_invite_email_signature', {
      first_name: vm.me.first_name, last_name: vm.me.last_name
    });

    modal.$scope.reset = modal.$scope.$hide;
    modal.$scope.submit = function (edited) {
      var promise = performanceReviewService
        .update
        .invite(invite.id, edited.first_name, edited.last_name, edited.transpire, subject, body, signature, edited.email);

      if (isOngoingInvite) {
        promise.then(_showEmailSentModal);
      }

      return promise
        .then(vm._requestAll)
        .finally(modal.$scope.$hide);
    };
  }

  function _showEmailSentModal(response) {
    $modal({template: require('./performance-review-invite.modal.mail-sent.html'), show: true});
    return response;
  }

  function postResendInvite(index, invite) {
    var modal = $modal({template: require('./performance-review-invite.modal.email.html'), show: true});

    modal.$scope.me = vm.me;
    modal.$scope.reset = modal.$scope.$hide;
    modal.$scope.submit = function (mail) {
      return performanceReviewService.util
        .inviteResend(invite.id, mail.subject, mail.message, mail.signature)
        .then(_showEmailSentModal)
        .finally(modal.$scope.$hide);
    };
  }

  function _requestAll() {
    performanceReviewService.list
      .invite(vm.round)
      .then(vm._refreshInvites)
      .then(vm._refreshInvited);
  }

  function _refreshAll(response) {
    vm._refreshInvites(response);
    vm._refreshInvited(response);
    return response;
  }

  function _refreshInvites(response) {
    vm.invites = response.data.invites;
    updateInvites();
    return response;
  }


  function _refreshInvited(response) {
    vm.invited = response.data.invited.map(function (invite) {
      if (invite.follow_up) {
        if (invite.follow_up.state !== 'follow_up_ready') {
          invite.transpire = invite.follow_up.appointment_datetime;
          invite.status = invite.follow_up.state_text;
          return invite;
        }
      }
      if (invite.initial_assessment) {
        invite.transpire = invite.initial_assessment.appointment_datetime;
        invite.status = invite.initial_assessment.state_text;
      }
      return invite;
    });
    return response;
  }

  function hasInvites() {
    return (vm.invites.length || []) > 0;
  }

  function hasInvited() {
    return (vm.invited.length || []) > 0;
  }

  function deleteInvite(index, invite) {
    performanceReviewService.delete
      .invite(invite.id)
      .then(vm._requestAll);
  }

  function isReviewDisabled(index, invite) {
    var basis = getBasis(invite);
    if (basis) {
      if (basis.follow_up) {
        if (basis.follow_up.state === 'follow_up_ready') {
          return false;
        }
        return true;
      }
      return !basis.agreement_completed;
    }
    return true;
  }

  function getBasis(invite) {
    var matched = vm.basis.filter(function (basis) {
      return basis.token === invite.token;
    });
    if (matched.length === 1) {
      return matched[0];
    }
    return undefined;
  }

  // function isAgreementCompleted(invite) {
  //   var basis = getBasis(invite);
  //   return basis.agreement_completed;
  // }


  function enableReview(index, invite) {
    var basis = getBasis(invite);
    if (basis.follow_up) {
      if (basis.follow_up.state === 'follow_up_ready') {
        $window.location.href = basis.follow_up.invite_url;
        return;
      }
    }

    var modal = $modal({template: require('./performance-review-invite.modal.review.html'), show: true});

    modal.$scope.me = vm.me;
    modal.$scope.invite = invite;
    modal.$scope.transpire = invite.transpire;
    modal.$scope.doReview = function (transpire) {

      performanceReviewService.util.updateTranspire(transpire, invite.id)
        .then(function () {
          performanceReviewService.update.openForReview(vm.round, {token: invite.token})
            .then(_showEmailSentModal)
            .then(vm._requestAll)
            .then(function () {
              var matched = vm.basis.filter(function (basis) {
                return basis.token === invite.token;
              });
              if (matched.length === 1) {
                matched[0].agreement_completed = false;
              }
            })
            .finally(modal.$scope.$hide);
        });
    };
  }
}

module.exports = PerformanceReviewInviteController;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/performance-review/performance-review-invite/performance-review-invite/performance-review-invite.controller.js
 ** module id = 249
 ** module chunks = 0
 **/